import type { SchemaBuilderConditionFieldModelProps } from "./schema-builder-condition-field-model.type";

import { Form, Select } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useSchemaBuilderFieldContext } from "../../schema-builder-field";

import { filterConditionOptions } from "./schema-builder-condition-field-model.helper";

export const SchemaBuilderConditionFieldModel = ({
  field,
}: SchemaBuilderConditionFieldModelProps) => {
  const { t } = useTranslation();
  const { formFields } = useSchemaBuilderFieldContext();

  const placeholder = t("schema:conditions.model.placeholder");
  const missingMessage = t("schema:conditions.model.missing");

  const [search, setSearch] = useState("");

  const filteredOptions = filterConditionOptions(formFields, search);

  return (
    <Form.Item
      name={[field.name, "model"]}
      rules={[{ required: true, message: missingMessage }]}
      className="schema-builder-condition-field-model"
    >
      <Select
        showSearch={{ filterOption: false, onSearch: setSearch }}
        allowClear
        defaultActiveFirstOption={false}
        notFoundContent={null}
        options={filteredOptions}
        placeholder={placeholder}
        aria-label={placeholder}
      />
    </Form.Item>
  );
};
